// extracted by mini-css-extract-plugin
module.exports = {"section":"_2CMYUyB9xYW-PJg8","mobileBlock":"_23XIaiILpQQ11Y_Y","actions":"qQ_rShj36tO9VueQ","xsButton":"_1Rvbz50q-AM1sqZe"};